/* @flow */
import React, { useContext, useState, useEffect } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import Breadcrumbs from '../../components/Breadcrumbs';
import TilesObjects from '../../components/TilesObjects';
import { generateBreadcrumbs } from '../../utils/breadcrumbs';
import {
	Root,
	Header,
	SearchWrapper,
	SearchPanel,
	Title,
	Subtitle,
	SubtitleLink,
	Section,
	SectionDark,
	List,
	ButtonWrapper,
	StyledButtonLink,
} from './styles';
import { Container } from '../../components/Layout/styles';
import { AppContext } from '../../components/AppContext';
import type { TCity } from '../../types/city';
import type { TArticlesExpert } from '../../types/articles';
import { getExpertArticlesData } from '../../actions/expertise';
import type { TDispatch } from '../../types/core';
import Button from '../../components/Button2.0';

const searchData = {
	type: 'text',
	placeholder: 'Поиск по разделу',
};

const Expertise = () => {
	const dispatch: TDispatch = useDispatch();
	const store = useStore();
	const expertise: TArticlesExpert = useSelector((state) => state.expertise);
	const city: TCity = useSelector((state) => state.city);
	const [search, setSearch] = useState('');
	const [result, setResult] = useState([]);

	const { articlesData: articles, isLoading } = expertise;

	const context = useContext(AppContext);
	const { fetch } = context;

	useEffect(() => {
		if (!isLoading) {
			getExpertArticlesData()(dispatch, store.getState, context);
		}
	}, [city]);

	const handleChangeSearch = async (value) => {
		setSearch(value);
		const searchURL = '/lexsApi/search/content';
		if (!value.length) {
			setResult([]);
		}
		if (value.length > 1) {
			const res = await fetch(searchURL, {
				method: 'POST',
				body: JSON.stringify({
					type: 'expertise',
					searchString: value,
					cityIds: city.cityIds,
				}),
			});
			const { data } = await res.json();
			setResult(data.items);
		}
	};

	const articlesBuyer = articles ? articles.buyers : [];
	const articlesTenant = articles ? articles.tenants : [];
	const articlesResearch = articles ? articles.analytics : [];

	const buyer = result.length ? result.filter((item) => item.type === 'mystery_buyer').slice(0, 7) : articlesBuyer;
	if (buyer[0]) buyer[0].tileType = 'wide';
	const lodger = result.length ? result.filter((item) => item.type === 'mystery_tenant').slice(0, 7) : articlesTenant;
	if (lodger[0]) lodger[0].tileType = 'wide';
	const research = result.length ? result.filter((item) => item.type === 'analytics').slice(0, 7) : articlesResearch;
	if (research[0]) research[0].tileType = 'wide';

	const breadCrumbsNew = generateBreadcrumbs(city.link, [
		{
			index: 3,
			title: 'Экспертиза',
			link: `/${city.link}/expert/`,
		},
	]);

	return (
		<Root>
			<Container>
				<Breadcrumbs data={breadCrumbsNew} />

				<Header>
					<Title>Экспертиза недвижимости</Title>
					<SearchWrapper>
						<SearchPanel data={searchData} value={search} handleChangeSearch={handleChangeSearch} />
					</SearchWrapper>
				</Header>
			</Container>

			{buyer?.length > 0 && (
				<Section>
					<Container>
						<Subtitle>
							<SubtitleLink to={`/${city.link}/expert/tainyi-pokupatel/`}>Тайный покупатель</SubtitleLink>
						</Subtitle>

						<List>
							<TilesObjects data={buyer} label="Тайный покупатель" url="tainyi-pokupatel" />
						</List>

						<ButtonWrapper>
							<Button
								isLink
								size="s"
								color="gray"
								style={{ padding: '0 30px' }}
								to={`/${city.link}/expert/tainyi-pokupatel/`}
							>
								Все обзоры
							</Button>
						</ButtonWrapper>
					</Container>
				</Section>
			)}

			{lodger?.length > 0 && (
				<SectionDark>
					<Container>
						<Subtitle>
							<SubtitleLink to={`/${city.link}/expert/tainyi-zhilec/`}>Тайный жилец</SubtitleLink>
						</Subtitle>

						<List>
							<TilesObjects data={lodger} label="Тайный жилец" url="tainyi-zhilec" />
						</List>
						<ButtonWrapper>
							<Button
								isLink
								size="s"
								color="white"
								style={{ padding: '0 30px' }}
								to={`/${city.link}/expert/tainyi-zhilec/`}
							>
								Все обзоры
							</Button>
						</ButtonWrapper>
					</Container>
				</SectionDark>
			)}

			{research?.length > 0 && (
				<Section>
					<Container>
						<Subtitle>
							<SubtitleLink to={`/${city.link}/expert/research/`}>Исследования</SubtitleLink>
						</Subtitle>

						<List>
							<TilesObjects data={research} label="Исследования" url="research" />
						</List>
						<ButtonWrapper>
							<Button
								isLink
								size="s"
								color="gray"
								style={{ padding: '0 30px' }}
								to={`/${city.link}/expert/research/`}
							>
								Все исследования
							</Button>
						</ButtonWrapper>
					</Container>
				</Section>
			)}
		</Root>
	);
};

export default Expertise;
